import { render, staticRenderFns } from "./SeatPicker.vue?vue&type=template&id=30c2f31a"
import script from "./SeatPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./SeatPicker.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports